import React from "react";
import styles from "./ArticleCardHorizontal.module.scss";

const ArticleCardHorizontal = ({ article, handleArticleClick }) => {
  return (
    <div
      className={styles.article}
      onClick={() => console.log("Card clicked.")}
    >
      <div className={styles.cardImage}>
        <img src={article.image} alt={article.title} />
      </div>
      <div className={styles.cardBody}>
        <h3
          className={styles.title}
          onClick={() => handleArticleClick(article)}
        >
          {article.title}
        </h3>
        <div className={styles.fullname}>{article.artistFullName}</div>
        <div className={styles.date}>{article.date}</div>
      </div>
    </div>
  );
};

export default ArticleCardHorizontal;
